import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { usePayrollPrimerSocialTrustABTestAdapter } from '@perpay-web/hooks/abTests/usePayrollPrimerSocialTrustABTest';

const PayrollPrimerSwitcherDataModule = composeDataModules([
    usePayrollPrimerSocialTrustABTestAdapter,
]);

const getRoot = (state) => state.dataModules.payrollPrimerSwitcher;

export const payrollPrimerSwitcherDataModule = PayrollPrimerSwitcherDataModule({
    getRoot,
    key: 'PAYROLL_PRIMER_SWITCHER',
});
